import { useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';

export default function TabNumberAdornment({ count }: { count: number }) {
  const theme = useTheme();

  return (
    <Typography
      component="span"
      sx={{ color: theme.brandV2.colors.treadGray4, fontSize: '12px' }}
    >
      {count}
    </Typography>
  );
}
